import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _bookingPolicy = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _bookingPolicyWithServices = {
    bookingPolicy: '_bookingPolicy',
    services: '_service',
    connectedServices: '_service',
};
var _bulkCreateServicesRequest = { services: '_service' };
var _bulkCreateServicesResponse = { results: '_bulkServiceResult' };
var _bulkDeleteServicesByFilterRequest = {};
var _bulkDeleteServicesByFilterResponse = {};
var _bulkDeleteServicesRequest = {};
var _bulkDeleteServicesResponse = { results: '_bulkServiceResult' };
var _bulkServiceResult = { item: '_service' };
var _bulkUpdateServicesByFilterRequest = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _bulkUpdateServicesByFilterResponse = {};
var _bulkUpdateServicesRequest = { services: '_maskedService' };
var _bulkUpdateServicesResponse = { results: '_bulkServiceResult' };
var _businessLocationOptions = { address: '_address' };
var _businessLocations = { locations: '_location' };
var _cloneServiceRequest = {};
var _cloneServiceResponse = { service: '_service' };
var _countServicesRequest = {};
var _countServicesResponse = {};
var _createAddOnGroupRequest = {};
var _createAddOnGroupResponse = {};
var _createServiceRequest = { service: '_service' };
var _createServiceResponse = { service: '_service' };
var _cursorSearch = { aggregations: '_aggregation' };
var _customLocationOptions = { address: '_address' };
var _deleteAddOnGroupRequest = {};
var _deleteAddOnGroupResponse = {};
var _deleteServiceRequest = {};
var _deleteServiceResponse = {};
var _disablePricingPlansForServiceRequest = {};
var _disablePricingPlansForServiceResponse = { service: '_service' };
var _enablePricingPlansForServiceRequest = {};
var _enablePricingPlansForServiceResponse = { service: '_service' };
var _getServiceAvailabilityConstraintsRequest = {};
var _getServiceAvailabilityConstraintsResponse = {
    constraints: '_serviceAvailabilityConstraints',
};
var _getServiceRequest = {};
var _getServiceResponse = { service: '_service' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listAddOnGroupsByServiceIdRequest = {};
var _listAddOnGroupsByServiceIdResponse = {};
var _location = {
    business: '_businessLocationOptions',
    custom: '_customLocationOptions',
    calculatedAddress: '_address',
};
var _maskedService = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _media = {
    items: '_mediaItem',
    mainMedia: '_mediaItem',
    coverMedia: '_mediaItem',
};
var _mediaItem = { image: '_image' };
var _moveToNewLocationsOptions = { newLocation: '_location' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryBookingFormsRequest = {};
var _queryBookingFormsResponse = {};
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = {};
var _queryLocationsRequest = {};
var _queryLocationsResponse = { businessLocations: '_businessLocations' };
var _queryPoliciesRequest = {};
var _queryPoliciesResponse = {
    bookingPolicies: '_bookingPolicyWithServices',
};
var _queryServicesMultiLanguageRequest = {};
var _queryServicesMultiLanguageResponse = {
    services: '_service',
    translatedServices: '_service',
};
var _queryServicesRequest = {};
var _queryServicesResponse = { services: '_service' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _removedLocationSessionsAction = {
    moveToLocationOptions: '_moveToNewLocationsOptions',
};
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _schedule = {
    firstSessionStart: 'google.protobuf.Timestamp',
    lastSessionEnd: 'google.protobuf.Timestamp',
};
var _searchServicesRequest = { search: '_cursorSearch' };
var _searchServicesResponse = {
    services: '_service',
    aggregationData: '_aggregationData',
};
var _service = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    media: '_media',
    locations: '_location',
    bookingPolicy: '_bookingPolicy',
    schedule: '_schedule',
    staffMembers: '_staffMember',
    staffMemberDetails: '_staffMemberDetails',
    supportedSlugs: '_slug',
    mainSlug: '_slug',
};
var _serviceAvailabilityConstraints = {
    bookingPolicy: '_bookingPolicy',
    schedule: '_schedule',
    locations: '_location',
};
var _setAddOnsForGroupRequest = {};
var _setAddOnsForGroupResponse = {};
var _setCustomSlugRequest = {};
var _setCustomSlugResponse = { slug: '_slug', service: '_service' };
var _setServiceLocationsRequest = {
    locations: '_location',
    removedLocationSessionsAction: '_removedLocationSessionsAction',
};
var _setServiceLocationsResponse = { service: '_service' };
var _slug = { createdDate: 'google.protobuf.Timestamp' };
var _staffMediaItem = { image: '_image' };
var _staffMember = { mainMedia: '_staffMediaItem' };
var _staffMemberDetails = { staffMembers: '_staffMember' };
var _updateAddOnGroupRequest = { mask: 'google.protobuf.FieldMask' };
var _updateAddOnGroupResponse = {};
var _updateServiceRequest = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _updateServiceResponse = { service: '_service' };
var _validateServiceRequest = { service: '_service' };
var _validateServiceResponse = {};
var _validateSlugRequest = {};
var _validateSlugResponse = {};
function resolveWixBookingsServicesV2ServicesServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-2',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
            {
                srcPath: '/bookings/services/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-2',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixBookingsServicesV2AddOnGroupsServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-2',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
            {
                srcPath: '/bookings/services/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-2',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new add-on group for a service and updates the service's `addOnGroups` array. */
export function createAddOnGroup(payload) {
    var _a = serializer(_createAddOnGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAddOnGroupResponse, {}).fromJSON;
    function __createAddOnGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.CreateAddOnGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
                protoPath: '/v2/services/add-on-groups/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAddOnGroup.fromReq = fromReq;
    __createAddOnGroup.__isAmbassador = true;
    return __createAddOnGroup;
}
/**
 * Deletes an add-on group.
 *
 *
 * Deleting the group doesn't delete individual add-ons.
 * Any add-on not associated with another group isn't available for customers to book.
 */
export function deleteAddOnGroup(payload) {
    var _a = serializer(_deleteAddOnGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAddOnGroupResponse, {}).fromJSON;
    function __deleteAddOnGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.DeleteAddOnGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
                protoPath: '/v2/services/add-on-groups/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAddOnGroup.fromReq = fromReq;
    __deleteAddOnGroup.__isAmbassador = true;
    return __deleteAddOnGroup;
}
/**
 * Updates an add-on group.
 *
 *
 * To update only add-on display order, call [Set Add Ons For Group](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/set-add-ons-for-group) instead.
 */
export function updateAddOnGroup(payload) {
    var _a = serializer(_updateAddOnGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAddOnGroupResponse, {}).fromJSON;
    function __updateAddOnGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.UpdateAddOnGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
                protoPath: '/v2/services/add-on-groups/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAddOnGroup.fromReq = fromReq;
    __updateAddOnGroup.__isAmbassador = true;
    return __updateAddOnGroup;
}
/**
 * Retrieves add-on groups for a service with enriched add-on details.
 *
 *
 * Add-on details are returned based on their display order.
 *
 * If you specify `groupIds`, only those groups are returned.
 * By default, all groups associated with the service are returned.
 */
export function listAddOnGroupsByServiceId(payload) {
    var _a = serializer(_listAddOnGroupsByServiceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAddOnGroupsByServiceIdResponse, {}).fromJSON;
    function __listAddOnGroupsByServiceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.ListAddOnGroupsByServiceId',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
                protoPath: '/v2/services/add-on-groups/list-add-on-groups-by-service-id',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAddOnGroupsByServiceId.fromReq = fromReq;
    __listAddOnGroupsByServiceId.__isAmbassador = true;
    return __listAddOnGroupsByServiceId;
}
/**
 * Sets the add-ons for a specific group, replacing any existing add-ons in the group.
 *
 *
 * Call this method when you want to:
 * - Add new add-ons to a group.
 * - Remove add-ons from a group.
 * - Reorder existing add-ons for optimal customer presentation.
 *
 * The order of add-ons in the request determines their display sequence to customers.
 * All specified add-ons must already exist before adding them to a group.
 *
 * For updating other add-on group properties, for example `name`, `prompt`, or `constraints`, call [Update Add On Group](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group) instead.
 */
export function setAddOnsForGroup(payload) {
    var _a = serializer(_setAddOnsForGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setAddOnsForGroupResponse, {}).fromJSON;
    function __setAddOnsForGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.SetAddOnsForGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
                protoPath: '/v2/services/add-on-groups/set-add-ons-for-group',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setAddOnsForGroup.fromReq = fromReq;
    __setAddOnsForGroup.__isAmbassador = true;
    return __setAddOnsForGroup;
}
/**
 * Creates a service.
 *
 *
 * ### Required fields
 *
 * When creating a service you must specify the following fields:
 * - `type`
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)):
 * Whether it's an appointment-based service, class, or course.
 * - `name`: Service name that's displayed to customers.
 * - `onlineBooking`:
 * Settings determining whether customers can book online, whether the business
 * must manually confirm bookings, and whether customers can request to book an
 * appointment time slot that already has a booking request awaiting business
 * confirmation.
 * - `payment`
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)):
 * How customers can pay when signing up for the service.
 * - `defaultCapacity`: The maximum number of customers that can book the service. Required for all service types. For appointment-based services, it must be `1`.
 *
 * #### Session durations
 *
 * Depending on which type of service you're creating, you may also need to specify
 * supported session durations.
 *
 * __Classes and courses__
 *
 * Don't specify `schedule.availabilityConstraints.sessionDurations`.
 *
 * __Appointment-based services without varied pricing based on session length__
 *
 * Specify the single supported session duration in the
 * `schedule.availabilityConstraints.sessionDurations` array.
 *
 * __Appointment-based services with varied pricing based on session length__
 *
 * - Specify all supported session durations in `schedule.availabilityConstraints.sessionDurations`.
 * - Note that Wix Bookings doesn't display these values to customers and
 * ignores them in pricing and availability calculations. Instead session
 * durations are retrieved from the relevant service variants
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)).
 * - It is mandatory to specify `schedule.availabilityConstraints.sessionDurations`,
 * even though these values are ignored.
 */
export function createService(payload) {
    var _a = serializer(_createServiceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __createService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CreateService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createService.fromReq = fromReq;
    __createService.__isAmbassador = true;
    return __createService;
}
/**
 * Validates a service.
 *
 *
 * ### Required fields
 *
 * A valid service must include the following fields:
 * - `type`
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)):
 * Whether it's an appointment-based service, class, or course.
 * - `name`: Service name that's displayed to customers.
 * - `onlineBooking`:
 * Settings determining whether customer can book online, whether the business
 * must manually confirm bookings,
 * and whether customers can request to book an appointment time slot that
 * already has a booking request awaiting business confirmation.
 * - `payment`
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)):
 * How customers can pay when signing up for the service.
 */
export function validateService(payload) {
    var _a = serializer(_validateServiceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateServiceResponse, {}).fromJSON;
    function __validateService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.ValidateService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateService.fromReq = fromReq;
    __validateService.__isAmbassador = true;
    return __validateService;
}
/**
 * Creates multiple services.
 *
 *
 * See Create Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/create-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/create-service))
 * for more details.
 */
export function bulkCreateServices(payload) {
    var _a = serializer(_bulkCreateServicesRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkCreateServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkCreateServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateServices.fromReq = fromReq;
    __bulkCreateServices.__isAmbassador = true;
    return __bulkCreateServices;
}
/** Retrieves a service. */
export function getService(payload) {
    var _a = serializer(_getServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __getService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'GET',
            methodFqn: 'wix.bookings.services.v2.ServicesService.GetService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getService.fromReq = fromReq;
    __getService.__isAmbassador = true;
    return __getService;
}
/** Retrieves the service constraints for availability calculation */
export function getServiceAvailabilityConstraints(payload) {
    var _a = serializer(_getServiceAvailabilityConstraintsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceAvailabilityConstraintsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
        _schedule: _schedule,
        _serviceAvailabilityConstraints: _serviceAvailabilityConstraints,
    }).fromJSON;
    function __getServiceAvailabilityConstraints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'GET',
            methodFqn: 'wix.bookings.services.v2.ServicesService.GetServiceAvailabilityConstraints',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/availability/constraints',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getServiceAvailabilityConstraints.fromReq = fromReq;
    __getServiceAvailabilityConstraints.__isAmbassador = true;
    return __getServiceAvailabilityConstraints;
}
/**
 * Updates a service.
 *
 *
 * Each time the service is updated, `revision` increments by 1. You must
 * include the number of the existing revision when updating the service.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 *
 * ### Session durations
 *
 * Specify `schedule.availabilityConstraints.sessionDurations`
 * only if you want to update it for appointment-based services without varied
 * pricing based on session length. Don't specify `schedule.availabilityConstraints.sessionDurations`
 * for all other appointment-based services, classes, or courses. See Create Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/create-service#session-durations) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/create-service#session-durations))
 * for more details.
 *
 * ### Service locations
 *
 * Don't use Update Service to modify service locations. Instead, use Set Service Locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/set-service-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/set-service-locations)), which provides options for handling existing sessions when locations are changed.
 *
 * ### Add-on groups
 *
 * Don't use Update Service to modify service add-on groups. Use these dedicated methods instead:
 * - **Update add-on group properties**: Call Update Add On Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group)).
 * - **Update add-on display order**: Call Set Add Ons For Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group)).
 */
export function updateService(payload) {
    var _a = serializer(_updateServiceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __updateService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'PATCH',
            methodFqn: 'wix.bookings.services.v2.ServicesService.UpdateService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{service.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateService.fromReq = fromReq;
    __updateService.__isAmbassador = true;
    return __updateService;
}
/**
 * Updates up to 100 services.
 *
 *
 * See Update Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
 * for more details.
 *
 * The call succeeds even if one or more individual services can't be updated.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkUpdateServices(payload) {
    var _a = serializer(_bulkUpdateServicesRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _maskedService: _maskedService,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkUpdateServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateServices.fromReq = fromReq;
    __bulkUpdateServices.__isAmbassador = true;
    return __bulkUpdateServices;
}
/**
 * Updates multiple services by filter.
 *
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
 * for more details.
 *
 * See Update Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
 * for more details about updating a service.
 *
 * The call succeeds even if one or more individual services can't be updated.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkUpdateServicesByFilter(payload) {
    var _a = serializer(_bulkUpdateServicesByFilterRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateServicesByFilterResponse, {}).fromJSON;
    function __bulkUpdateServicesByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServicesByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateServicesByFilter.fromReq = fromReq;
    __bulkUpdateServicesByFilter.__isAmbassador = true;
    return __bulkUpdateServicesByFilter;
}
/**
 * Deletes a service.
 *
 *
 * Specify `{"preserveFutureSessionsWithParticipants": true}` to retain all
 * future sessions for the service. By default, all future sessions are canceled.
 */
export function deleteService(payload) {
    var _a = serializer(_deleteServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteServiceResponse, {}).fromJSON;
    function __deleteService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'DELETE',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DeleteService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteService.fromReq = fromReq;
    __deleteService.__isAmbassador = true;
    return __deleteService;
}
/**
 * Deletes multiple services.
 *
 *
 * See Delete Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/delete-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service))
 * for more details about deleting a service.
 *
 * The call succeeds even if one or more individual services can't be deleted.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkDeleteServices(payload) {
    var _a = serializer(_bulkDeleteServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkDeleteServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteServices.fromReq = fromReq;
    __bulkDeleteServices.__isAmbassador = true;
    return __bulkDeleteServices;
}
/**
 * Deletes multiple services by filter.
 *
 *
 * See Delete Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/delete-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service))
 * for more details about deleting a service.
 *
 * The call succeeds even if one or more individual services can't be deleted.
 * Information about failures is returned in `bulkActionMetadata`.
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
 * for more details.
 *
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
 */
export function bulkDeleteServicesByFilter(payload) {
    var _a = serializer(_bulkDeleteServicesByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteServicesByFilterResponse, {}).fromJSON;
    function __bulkDeleteServicesByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServicesByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteServicesByFilter.fromReq = fromReq;
    __bulkDeleteServicesByFilter.__isAmbassador = true;
    return __bulkDeleteServicesByFilter;
}
/**
 * Retrieves a list of up to 100 services, given the provided paging,
 * filtering, and sorting.
 *
 *
 * ### Defaults
 *
 * Query Services has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `paging.limit` set to `100`.
 * + `paging.offset` set to `0`.
 *
 * ### Filters
 *
 * When using filters for dates, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryServices(payload) {
    var _a = serializer(_queryServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServices.fromReq = fromReq;
    __queryServices.__isAmbassador = true;
    return __queryServices;
}
/**
 * Retrieves a list of up to 100 services, given the provided filtering, paging,
 * and sorting.
 *
 *
 * ### Defaults
 *
 * Search Services has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `paging.limit` set to `100`.
 * + `paging.offset` set to `0`.
 *
 * ### Filters
 *
 * When using filters for dates, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 *
 * ### See also
 *
 * To learn about working with Search methods, see API Query Language
 * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language))
 * and Sorting and Paging
 * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging)).
 */
export function searchServices(payload) {
    var _a = serializer(_searchServicesRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __searchServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SearchServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchServices.fromReq = fromReq;
    __searchServices.__isAmbassador = true;
    return __searchServices;
}
/**
 * Retrieves a list of up to 100 booking policies
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)),
 * and information about the services that are connected to them,
 * given the provided filtering, paging, and sorting.
 *
 * ### Defaults
 *
 * Query Policies has the following default settings, which you can override:
 *
 * + Sorted by `id` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ### Filters
 *
 * For a complete list of supported filters, refer to Booking Policies API: Supported Filters
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters)).
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### Returned services
 *
 * If a booking policy is connected to more than 5 services, only a subset of
 * those services is returned. The `bookingPolicies.totalServiceCount` values
 * indicate the total number of services linked to each policy. You can call Search Services
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/search-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/search-services))
 * and specify the relevant policy ID in the filter to retrieve all services
 * connected to the booking policy.
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryPolicies(payload) {
    var _a = serializer(_queryPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPoliciesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bookingPolicyWithServices: _bookingPolicyWithServices,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryPolicies',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/policies/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPolicies.fromReq = fromReq;
    __queryPolicies.__isAmbassador = true;
    return __queryPolicies;
}
/**
 * Retrieves a list of up to 100 booking forms
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/forms/introduction) | [REST](https://dev.wix.com/docs/rest/crm/forms/form-schemas/form-object)),
 * and information about the services that are connected to them,
 * given the provided filtering, paging, and sorting.
 *
 *
 * ### Defaults
 *
 * Query Booking Forms has the following default settings, which you can override:
 *
 * + Sorted by `id` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ### Filters
 *
 * For a complete list of supported filters, refer to Forms API: Supported Filters
 * ([REST](https://dev.wix.com/docs/rest/crm/forms/form-schemas/form-object)).
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### Returned services
 *
 * If a booking policy is connected to more than 5 services, only a subset of
 * these service IDs and names is returned. The `bookingForms.totalServiceCount`
 * values indicate the total number of services linked to each form. You can call Query Services
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/query-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/query-services))
 * and specify the relevant form ID in the filter to retrieve all services
 * connected to the booking form.
 *
 * ### Default booking forms
 *
 * By default, all Wix Bookings services use a standard booking form. To retrieve
 * a site's default booking form with Query Booking Forms, specify
 * `{"conditionalFields": ["DEFAULT_BOOKING_FORM"]}`.
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryBookingForms(payload) {
    var _a = serializer(_queryBookingFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingFormsResponse, {}).fromJSON;
    function __queryBookingForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryBookingForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/booking-forms/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBookingForms.fromReq = fromReq;
    __queryBookingForms.__isAmbassador = true;
    return __queryBookingForms;
}
/**
 * Counts how many services match the given filter.
 *
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
 * for more details.
 *
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)
 */
export function countServices(payload) {
    var _a = serializer(_countServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countServicesResponse, {}).fromJSON;
    function __countServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CountServices',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countServices.fromReq = fromReq;
    __countServices.__isAmbassador = true;
    return __countServices;
}
/**
 * Retrieves 3 separate lists of business, custom, and customer locations
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)),
 * given the provided filtering, and whether each location is connected to at
 * least one of the site's services.
 *
 *
 * ### Defaults
 *
 * Query Locations has the following default setting, which you can't override:
 * Sorted by `id` in ascending order.
 *
 * ### Filters
 *
 * For a complete list of supported filters, refer to the `location` object
 * ([REST](https://dev.wix.com/docs/rest/business-management/locations/location-object)).
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryLocations(payload) {
    var _a = serializer(_queryLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _businessLocationOptions: _businessLocationOptions,
        _businessLocations: _businessLocations,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
    }).fromJSON;
    function __queryLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryLocations',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/locations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLocations.fromReq = fromReq;
    __queryLocations.__isAmbassador = true;
    return __queryLocations;
}
/**
 * Retrieves a list of service categories ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories-v2/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v2/introduction)), given the provided filtering.
 *
 *
 * ### Defaults
 *
 * Query Categories has the following default setting, which you can't override:
 * Sorted by `id` in ascending order.
 *
 * ### Filters
 *
 * For a complete list of supported filters, refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering)).
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {}).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Query services in both the main language and the provided language according to the linguist aspect. */
export function queryServicesMultiLanguage(payload) {
    var _a = serializer(_queryServicesMultiLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServicesMultiLanguageResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryServicesMultiLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServicesMultiLanguage',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/query/multi-language',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServicesMultiLanguage.fromReq = fromReq;
    __queryServicesMultiLanguage.__isAmbassador = true;
    return __queryServicesMultiLanguage;
}
/**
 * Replaces the list of the locations
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction))
 * where the business offers the service.
 *
 *
 * ### Consequences for customers
 *
 * Removing a service location may impact existing sessions and their
 * participants. If you remove at least one service location, you must
 * specify `removedLocationSessionsAction` to indicate what happens to all
 * future sessions scheduled at this location.
 *
 * - **Keep existing location**: If you want to retain future sessions at their
 * originally scheduled location, specify
 * `{"removedLocationSessionsAction.action": "KEEP_AT_CURRENT_LOCATION"}`.
 * This ensures nothing changes for the customer, but the business must be
 * able to provide access to the removed location in the future.
 * - **Update location**: If you want to update the location for future sessions
 * scheduled at the removed location, specify
 * `{"removedLocationSessionsAction.action": "MOVE_TO_LOCATION"}` and
 * `moveToLocationOptions.newLocation`.
 *
 * You can't mix and match to keep some sessions at the previous location while
 * moving other sessions to an updated location.
 *
 * Past session details aren't changed, no matter which option you choose for
 * future sessions.
 *
 * Future sessions scheduled for a location defined by the customer are also not
 * updated.
 *
 * ### Specify location details
 *
 * Depending on whether the new or updated location is a business or custom location,
 * you need to specify different fields.
 *
 * - **Business location**: Specify the relevant location ID
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction))
 * in `locations.business.id`.
 * - **Custom location**: Specify the complete address object as
 * `locations.custom.address`.
 *
 * ### Participant notifications
 *
 * You can specify a `participantNotification.message` that's immediately send
 * to all customers who had booked at a changed location. Ensure
 * `participantNotification.notifyParticipants` is set to `true` to send the
 * message.
 */
export function setServiceLocations(payload) {
    var _a = serializer(_setServiceLocationsRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
        _moveToNewLocationsOptions: _moveToNewLocationsOptions,
        _removedLocationSessionsAction: _removedLocationSessionsAction,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setServiceLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __setServiceLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetServiceLocations',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/locations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setServiceLocations.fromReq = fromReq;
    __setServiceLocations.__isAmbassador = true;
    return __setServiceLocations;
}
/**
 * Adds a list of pricing plan IDs
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
 * to a service's `payment.pricingPlanIds` array.
 *
 *
 * The call doesn't validate whether the service's `payment.options.pricingPlan`
 * is set to `true`. If it's set to `false`, customers aren't able to pay
 * for their bookings using pricing plans. You can call Update Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
 * to change a service's supported payment methods.
 */
export function enablePricingPlansForService(payload) {
    var _a = serializer(_enablePricingPlansForServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enablePricingPlansForServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __enablePricingPlansForService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.EnablePricingPlansForService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enablePricingPlansForService.fromReq = fromReq;
    __enablePricingPlansForService.__isAmbassador = true;
    return __enablePricingPlansForService;
}
/**
 * Removes a list of pricing plan IDs
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
 * from a service's `payment.pricingPlanIds` array.
 *
 *
 * If you remove all pricing plan IDs from `payment.pricingPlanIds` and the
 * service supports only payments by pricing plan, customers will no longer be
 * able to book the service, as they will have no payment options available.
 */
export function disablePricingPlansForService(payload) {
    var _a = serializer(_disablePricingPlansForServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disablePricingPlansForServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __disablePricingPlansForService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DisablePricingPlansForService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disablePricingPlansForService.fromReq = fromReq;
    __disablePricingPlansForService.__isAmbassador = true;
    return __disablePricingPlansForService;
}
/**
 * Sets a new active slug for the service.
 *
 *
 * The call fails if at least one of these conditions is met:
 * - The slug doesn't adheres to the supported format.
 * - Another service is currently using the slug.
 * - Another service has used the slug in the past.
 */
export function setCustomSlug(payload) {
    var _a = serializer(_setCustomSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setCustomSlugResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __setCustomSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetCustomSlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/slugs/custom',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setCustomSlug.fromReq = fromReq;
    __setCustomSlug.__isAmbassador = true;
    return __setCustomSlug;
}
/**
 * Checks whether a custom slug is validate for the service.
 *
 *
 * The checks include:
 * - The slug adheres to the supported format.
 * - No other service is currently using the slug.
 * - No other service has used the slug in the past.
 *
 * The call fails if at least one of the checks fails.
 */
export function validateSlug(payload) {
    var _a = serializer(_validateSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateSlugResponse, {}).fromJSON;
    function __validateSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.ValidateSlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/slugs/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateSlug.fromReq = fromReq;
    __validateSlug.__isAmbassador = true;
    return __validateSlug;
}
/**
 * Clones a service.
 *
 *
 * ### Connected entities
 *
 * By default, not all entities connected to the service are cloned.
 *
 * #### Schedule
 *
 * Wix Bookings automatically creates a new active schedule
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction))
 * for the cloned service. If Wix Bookings can't create this schedule, the
 * Clone Service call fails.
 *
 * - __For appointment-based services__: Future appointments aren't added to the
 * cloned service's schedule. Use the Events API
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
 * to add them as needed.
 * - __For classes and courses__: Future one-time events aren't added to the
 * cloned service's schedule, while future recurring events are added
 * asynchronously. The Clone Service call always succeeds, whether or not
 * recurring events are added.
 * If the response includes `RECURRING_EVENTS` in the `errors` array, it means the
 * cloned service doesn't have future recurring events, even though the original
 * service does. You can either delete the cloned service and try again or use
 * the Events API
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
 * to add missing events to the schedule.
 *
 * Wix Bookings never adds past events to the cloned service's schedule.
 *
 * #### Service options and variants
 *
 * If the original service has variants
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
 * they're cloned asynchronously. The Clone Service call always succeeds,
 * regardless of whether variants were cloned.
 *
 * If the response includes `OPTIONS_AND_VARIANTS` in the `errors` array, the cloned
 * service doesn't have variants, even though the original service does. You can
 * delete the cloned service and call Clone Service again, or use the
 * _Service Options And Variants API_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction))
 * to add variants.
 *
 * #### Booking form
 *
 * The original service's booking form isn't cloned, whether it's
 * the default or a custom booking form.
 *
 * #### Pricing plans
 *
 * If the original service's accepts payments via pricing plans
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/pricing-plans/pricing-plans/plans/introduction)),
 * the cloned service's `payment.options.pricingPlan` is also set to `true`. To
 * accept specific pricing plans, call Enable Pricing Plans For Service
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/enable-pricing-plans-for-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/enable-pricing-plans-for-service)),
 * after cloning the service. If the original service accepts only
 * pricing plan payments and you don't call Enable Pricing Plans For Service
 * after cloning the service, customers will be unable to book the service.
 */
export function cloneService(payload) {
    var _a = serializer(_cloneServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __cloneService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CloneService',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneService.fromReq = fromReq;
    __cloneService.__isAmbassador = true;
    return __cloneService;
}
//# sourceMappingURL=http.impl.js.map